<template>
  <v-container fluid>
    <h1>
      Avion & Acella - FormSite Unsubscribes
    </h1>
    <v-form @submit.prevent="submit">
      <v-card class="mb-4">
        <v-card-text>
          <p>
            Upload the FormSite CSV file to unsubscribe them from Mobile Locker emails.
          </p>
          <v-file-input v-model="form.file"
                        label="FormSite CSV File"
                        accept=".csv"
                        hint="Select a CSV file from your computer"
                        persistent-hint>
          </v-file-input>

        </v-card-text>
        <v-card-actions>
          <v-btn type="submit"
                 :disabled="!isFileValid || form.busy"
                 color="primary">
            Upload
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-alert v-if="error"
               type="error"
               tile>
        {{ error }}
      </v-alert>

      <v-card v-if="results">
        <v-card-title class="pb-0">
          {{ results.length | pluralize('row') }} processed
        </v-card-title>
        <v-simple-table dense>
          <thead>
          <tr>
            <td>
              Row
            </td>
            <td>
              Success
            </td>
            <td>
              Email address
            </td>
            <td>
              Message
            </td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="result in results"
              :key="result.id">
            <td class="text-right">
              {{ result.row }}
            </td>
            <td>
              <v-icon v-if="result.valid"
                      color="green">
                fas fa-check-circle
              </v-icon>
              <v-icon v-else
                      color="red">
                fas fa-exclamation-triangle
              </v-icon>
            </td>
            <td>
              {{ result.email }}
            </td>
            <td>
              {{ result.message }}
            </td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import {Form} from 'vform';
import axios from '../../../services/axiosService';

export default {
  data() {
    return {
      error: null,
      form: new Form({
        file: null,
      }),
      results: null,
    }
  },
  computed: {
    isFileValid() {
      if (this.form.file) {
        return this.form.file.type === 'text/csv';
      }
      return false;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {

    },
    submit() {
      if (this.isFileValid === false) {
        return;
      }
      this.form.startProcessing();
      this.error = null;
      this.results = null;
      const file = this.form.file;
      const formData = new FormData();
      formData.append('file', file, file.name);
      return axios.post(`/api/clients/avion/formsite/unsubscribe`, formData)
        .then(response => {
          this.results = response.data;
        })
        .catch(err => {
          this.error = err.message;
        })
        .finally(() => {
          this.form.busy = false;
        });
    }
  }
}
</script>
